import OrganizationApi from '../../api/organization-api.service';
import {IOrganizationApi, IOrganization} from '../../api/api.types';

export default class UserManagementController {
    private static readonly $inject = ['organizationApi', '$mdDialog', '$translate', '$scope'];

    private organizationList: IOrganization[];
    selectedOrganization: IOrganization;
    organizationListPromise:ng.IPromise<any>;

  constructor(
    private organizationApi: IOrganizationApi,
    private $mdDialog: ng.material.IDialogService,
    private $translate:ng.translate.ITranslateService,
    private $scope:ng.IScope
  ) {
    let self = this;
    self.organizationListPromise = organizationApi.getOrganizations()
        .then(function (data) {
            self.organizationList = data;
        });
  }

  onVerifyClick(organization: IOrganization) {
    let confirm = this.$mdDialog.confirm()
        .title('')
        .textContent(this.$translate.instant('PAYMENT_VERIFICATION_CONFIRMATION', {organization: organization.organization}))
        .ok(this.$translate.instant('VERIFY_PAYMENT'))
        .cancel(this.$translate.instant('CANCEL'));

    this.$mdDialog.show(confirm).then(() => {
      this.organizationApi.renewPayment(organization.id)
        .then((organization) => {
          this.organizationList.forEach((orgItem, index) => {
            if (orgItem.id === organization.id) {
              this.organizationList[index] = organization;
            }
          })
        });
      });
  }

}



/** WEBPACK FOOTER **
 ** ./app/hydromet/access/access.controller.ts
 **/